import React, { Fragment, useContext } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { Disclosure } from '@headlessui/react';
import { Squares2X2Icon } from '@heroicons/react/20/solid';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { CSS } from '@dnd-kit/utilities';
import {
  SortableListContext,
  SortableSubListContext,
} from '../../context/sortable-context';
import SubSortable from '../../SubSortable';
import {
  BaseSortableProps,
  ISortableCard,
} from '../../@types/sortable-list-types';
import { classNames } from '@geerd-nx/utils';

const SortableCard = <T extends { id: number }>({
  list,
  depth,
}: ISortableCard<T>) => {
  const {
    // handleSortedData,
    // listData,
    // onRowClick,
    // onClick,
    accessor,
    ListActions,
    ListContainer,
    placeholder,
  } = useContext<BaseSortableProps<T>>(SortableListContext);

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: list.id,
    });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
  };
  const PlaceholderComponent = React.memo(
    placeholder?.[depth]
      ? placeholder?.[depth]
      : () => <div className=" text-sm text-gray-600 p-4">No result found</div>
  );
  const ListActionsComponent = React.memo(ListActions[depth]);
  const ListContainerComponent = React.memo(ListContainer[depth]);
  return (
    <div ref={setNodeRef} style={style}>
      <div className="bg-white shadow overflow-hidden mb-4 p-4 sm:rounded-md">
        <Disclosure>
          {({ open }: { open: boolean }) => (
            <>
              <ul className="divide-y divide-gray-200">
                <li key={list.id}>
                  <div className="block">
                    <div className="px-4 py-4 flex items-center sm:px-6">
                      {<ListContainerComponent payload={list} />}
                      <button
                        {...listeners}
                        {...attributes}
                        type="button"
                        className=" float-right cursor-grab inline-flex items-center p-1 border border-transparent rounded shadow-sm text-gray-600 hover:text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-100"
                      >
                        <Squares2X2Icon
                          className="h-5 w-5"
                          aria-hidden="true"
                        />
                      </button>
                      <div className="ml-5 flex-shrink-0">
                        {<ListActionsComponent id={list.id} />}
                      </div>
                      {accessor.length !== depth && (
                        <Disclosure.Button as={Fragment}>
                          <span className="ml-6 h-7 flex items-center">
                            <ChevronDownIcon
                              className={classNames(
                                open ? '-rotate-180' : 'rotate-0',
                                'h-6 w-6 transform cursor-pointer'
                              )}
                              aria-hidden="true"
                            />
                          </span>
                        </Disclosure.Button>
                      )}
                    </div>
                  </div>
                </li>
              </ul>
              <Disclosure.Panel>
                <SortableSubListContext.Provider
                  value={{
                    depth,
                    list,
                    // ListActions,
                  }}
                >
                  {((list as any)?.[accessor[depth]] as Array<any>)?.length >
                  0 ? (
                    <SubSortable />
                  ) : (
                    <PlaceholderComponent />
                  )}
                </SortableSubListContext.Provider>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  );
};

export default SortableCard;
